import config from 'services/table/const';
import { formatDate } from 'utilities/common';
import Action from './table.action';

let table = { ...config };
table.url = '/user';
table.columns = {
    name: {
        title: 'Nama',
        sortable: true,
        format_number: false,
        width: 100,
        class: '',
        component: (row) => {
            return (
                <div className="table-col">
                    <div className="text-ellipsis fs-8 fw-semibold">{row?.name}</div>
                    <span className="info text-muted">{row?.username}</span>
                </div>
            );
        },
    },
    registered_at: {
        title: 'Terdaftar Pada',
        sortable: false,
        format_number: false,
        width: 100,
        class: '',
        component: (row) => {
            return (
                <div className="table-col">
                    <div className="text-ellipsis fs-8 fw-semibold">
                        {formatDate(row?.registered_at, 'DD MMM YYYY - HH:mm')} WIB
                    </div>
                </div>
            );
        },
    },
    last_login_at: {
        title: 'Aktifitas Terakhir',
        sortable: false,
        format_number: false,
        width: 100,
        class: '',
        component: (row) => {
            return (
                <div className="table-col">
                    <div className="text-ellipsis fs-8 fw-semibold">
                        {row?.last_activity_at !== '0001-01-01T00:00:00Z'
                            ? formatDate(row?.last_activity_at, 'DD MMM YYYY - HH:mm') + ' WIB'
                            : '-'}
                    </div>
                </div>
            );
        },
    },
    action: {
        title: '',
        sortable: false,
        width: 50,
        class: 'text-end',
        component: (row) => {
            return <Action data={row} customer_id={row?.customer_id} />;
        },
    },
};

export default table;
